import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { EntityService } from '../../services/entity-service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Entity } from '../../entity/entity';
import { UnrestrictedEntityUpdate } from '../../model/unrestricted-entity-update';
import { StringUtils } from '../../utils/string-utils';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-unrestricted-entity-changes-dialog',
  imports: [FormsModule, MatButtonModule],
  templateUrl: './unrestricted-entity-changes-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './unrestricted-entity-changes-dialog.component.css'
})
export class UnrestrictedEntityChangesDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<UnrestrictedEntityChangesDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);
  private entity: Entity;
  internalNotes: string;
  isBusy = false;
  errorMessage: string | undefined;

  constructor() {
    this.isBusy = true;
    this.entity = this.data.entity;
    this.internalNotes = this.entity.internalNotes;
  }

  canSave(): boolean {
    return !StringUtils.equalsIgnoreCase(this.internalNotes, this.entity.internalNotes) && StringUtils.isNotBlank(this.internalNotes);
  }

  save(): void {
    const changes = new UnrestrictedEntityUpdate();
    changes.entityId = this.entity.id.entityId;
    changes.revision = this.entity.id.entityRevision;
    changes.internalNotes = this.internalNotes;
    this.dialogRef.close(changes);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
